define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi",
	"csi/def/Action",
	"csi/xml"
], function(array,declare,csi,Action,xml) {

	return declare(null, {
		PATH_THEME_COLORS: "Child:__Parent__/Child:Theme/Child:ColorColorways",
		PATH_THEME: "Child:__Parent__/Child:Theme",

		_isColorInTheme: function(/*Context*/ctx, /*Boolean*/bEmptyOk) {
			var colorway = ctx.getNode();
			var	urlColor = colorway.ColorSpecification;
			var color = ctx.cache.getNode(urlColor);

			if (!color) {
				return bEmptyOk;
			} else if (color.__Parent__ != csi.EMPTY_URL && color.$Type == "ColorColorwayContext") {
				return true;
			}

			return array.some(ctx.cache.getPathNodes(colorway, this.PATH_THEME_COLORS), function(item) {
				return item.Actual == urlColor;
			});
		},

		_isThemeChangeable: function(/*Context*/ctx) {
			var colorway = ctx.getNode();
			var theme = ctx.cache.getPathNode(colorway, this.PATH_THEME);
			if (!theme)
				return false;

			return (theme.$FG & (xml.NODE_FLAG_FROZEN|xml.NODE_FLAG_NOEDIT)) == 0;
		}
	});
});